<template>
  <div class="sectionBlock">
    <h3>נתוני הרכב במודעה</h3>
    <div class="carInfo" v-if="carInfo">
      <div class="gallery" v-if="carInfo.images">
        <gallery :gallery="carInfo.images"></gallery>
      </div>
      <div>
        <car-data :car="carInfo"></car-data>
      </div>
    </div>
  </div>
  <div class="sectionBlock">
    <h3 class="subtitle">פרטים נוספים</h3>
    <div>
      <textarea v-model="freeText"></textarea>
    </div>
  </div>
  <div class="sectionBlock">
    <h3 class="subtitle">מסמכים נלווים</h3>
    <div class="uploadDocuments">
      <div>
        <AddGalleryFiles
					:car="carInfo"
          :multiple="false"
          :upload-text="'+ העלאת רישיון רכב'"
        ></AddGalleryFiles>
      </div>
      <div>
        <AddGalleryFiles
					:car="carInfo"
          :multiple="false"
          :upload-text="'+ העלאת בדיקת קניה'"
        ></AddGalleryFiles>
      </div>
    </div>
  </div>
  <div class="form-actions">
    <button type="button" @click="goBack()">חזרה</button>
    <button type="button" @click="saveAndContinue()">המשך</button>
  </div>
</template>
<script>
import CarData from "@/components/carData.vue";
import Gallery from "@/components/gallery.vue";
import AddGalleryFiles from "@/components/addGalleryFiles.vue";
import "swiper/swiper-bundle.css";

export default {
  name: "Summary",
  mounted() {
    this.getCarDetails();
  },
  components: {
    AddGalleryFiles,
    CarData,
    Gallery,
  },
  methods: {
		async getCarDetails() {
			if(this.$route.params.id){
				const id = this.$route.params.id;
				if(/^\d+$/.test(id)){
					this.carInfo = await this.locateCar(id)
					const textFormat =
							"רכב מספר %%car_number%% אותר בהצלחה, ניתן להמשיך ולמלא פרטי מודעה.";
					this.headerMessage = textFormat.replace(
							"%%car_number%%",
							this.carInfo.plate_number
					);
				}else{
					this.$store.commit('currentCarId', this.$route.params.id)
					this.carInfo = this.$store.getters.currentCar
					this.headerMessage = null;
				}
			}
		},
    goBack() {
      this.$router.push({
				name: 'car',
				params: {
					id: this.carInfo.id
				}
			});
    },
    saveAndContinue() {
      this.$router.push({
				name: 'thankyou'
			});
    },
  },
  data() {
    return {
      carInfo: null,
      freeText: null,
    };
  },
};
</script>
